import React, { Fragment, useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { Listbox, Transition } from "@headlessui/react";
import { CheckIcon, ChevronDownIcon } from "@heroicons/react/solid";
function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const DropdownSelector = ({ decreasingPrice, increasingPrice, decreasingWeight, orderType }) => {
  const filterOptions = ["desc-weight", "asc-price", "desc-price"];
  const [selected, setSelected] = useState(orderType ? orderType : filterOptions[0]);

  // display selected value = orderType
  useEffect(() => {
    if (orderType) {
      setSelected(orderType);
    }
    return null;
  }, [orderType])

  // algolia search index method to apply
  useEffect(() => {
    if (selected === "desc-weight") {
      decreasingWeight();
    }
    else if (selected === "asc-price") {
      increasingPrice();
    } else if (selected === "desc-price") {
      decreasingPrice();
    }
  }, [selected])

  // Translate value to display
  const toFrench = ((value) => {
    switch (value) {
      case "desc-price":
        return "Par prix décroissant";
        break;
      case "asc-price":
        return "Par prix croissant";
        break;
      default:
        return "Par pertinence";
    }
  })

  return (
    <Listbox value={selected} onChange={setSelected}>
      {({ open }) => (
        <>
          <Listbox.Label className="sr-only">Trier par</Listbox.Label>
          <div className="relative">
            <div className="inline-flex shadow-sm rounded-md divide-x divide-indigo-600">
              <div className="relative z-0 inline-flex shadow-sm rounded-md divide-x divide-indigo-600">
                <div className="relative inline-flex items-center bg-indigo-500 py-2 pl-3 pr-4 border border-transparent rounded-l-md shadow-sm text-black">
                  <CheckIcon className="h-5 w-5" aria-hidden="true" />
                  <p className="ml-2.5 text-xs lg:text-sm">{toFrench(selected)}</p>
                </div>
                <Listbox.Button className="relative inline-flex items-center bg-indigo-500 p-2 rounded-l-none rounded-r-md text-sm font-medium text-black hover:bg-indigo-600 focus:outline-none focus:z-10 focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-indigo-500">
                  <span className="sr-only">Trier par</span>
                  <ChevronDownIcon className="h-5 w-5 text-black" aria-hidden="true" />
                </Listbox.Button>
              </div>
            </div>
            <Transition
              show={open}
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Listbox.Options className="origin-top-right absolute z-10 mt-2 w-full xl:w-72 rounded-md shadow-lg overflow-hidden bg-white divide-y divide-gray-200 ring-1 ring-black ring-opacity-5 focus:outline-none">
                {filterOptions.map((option) => (
                  <Listbox.Option
                    key={option}
                    className={({ active }) =>
                      classNames(
                        active ? 'text-black bg-indigo-500' : 'text-gray-900',
                        'cursor-default select-none relative p-4 text-sm'
                      )
                    }
                    value={option}
                  >
                    {({ selected, active }) => (
                      <div className="flex flex-col">
                        <div className="flex justify-between">
                          <p className={selected ? 'font-semibold' : 'font-normal'}>{toFrench(option)}</p>
                          {selected ? (
                            <span className={active ? 'text-black' : 'text-indigo-500'}>
                              <CheckIcon className="h-5 w-5" aria-hidden="true" />
                            </span>
                          ) : null}
                        </div>
                      </div>
                    )}
                  </Listbox.Option>
                ))}
              </Listbox.Options>
            </Transition>
          </div>
        </>
      )}
    </Listbox>
  )
};
export default DropdownSelector;
DropdownSelector.propTypes = {
  increasingPrice: PropTypes.func,
  decreasingPrice: PropTypes.func,
  decreasingWeight: PropTypes.func
};

